import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import history from 'app/routes/history';
import Alert from 'app/components/general/Alert';
import _ from 'lodash';
import { IMatchPaymentsSelector } from 'app/types/selector';

import * as matchPaymentsActions from 'app/ducks/matchPayments/actions';
import * as teamActions from 'app/ducks/teams/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as matchPaymentsSelectors from 'app/ducks/matchPayments/selectors';
import * as teamsSelectors from 'app/ducks/teams/selectors';

import CartVariableMatch from './CartVariableMatch';
import CartBasicMatch from './CartBasicMatch';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    matchPayments: matchPaymentsSelectors.getMatchPayments(
      state,
    ),
    teams: teamsSelectors.getTeams(
      state,
    ),
    isLoading: state.payments.isLoading,
    errors: { ...state.paymentEvents.backendErrors },
  };
}

const actionCreators = _.merge(matchPaymentsActions, teamActions);

interface ICartProps {
  matchPayments: IMatchPaymentsSelector;
  teams: any;
  match: any;
  actions: any;
}

@(connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
})) as any)
export default class CartMatch extends React.Component<ICartProps, {}> {
  static defaultProps: ICartProps = {
    matchPayments: {},
    match: undefined,
    actions: undefined,
  };

  componentDidMount = () => {
    if (!_.isEmpty(this.props.match.params.matchPaymentId)) {
      this.props.actions.getMatchPayment(
        this.props.match.params.matchPaymentId,
      );
    }
    this.props.actions.getAllTeams();
  };

  render(): React.ReactNode {
    const { currentMatchPayment } = this.props.matchPayments;

    if (currentMatchPayment.id === this.props.match.params.matchPaymentId && !currentMatchPayment.paymentEnabled) {
      return (
        <div className="row">
          <div className="col">
            <Alert color="error">Payment is not enabled for this match.</Alert>
          </div>
        </div>
      );
    }
    // console.log(this.props.match.params.matchPaymentId === currentMatchPayment.id && _.includes(['paid', 'walkover'], currentMatchPayment.status));
    if (this.props.match.params.matchPaymentId === currentMatchPayment.id && _.includes(['paid', 'walkover'], currentMatchPayment.status)) {
      history.push(
        `/payment/match/${currentMatchPayment.id}/receipt`,
      );
    }
    if (!_.isEmpty(currentMatchPayment)) {
      const { fixtureMatch } = currentMatchPayment;
      if (!_.isEmpty(fixtureMatch)) {
        if (currentMatchPayment.paymentType === 'event-variable') {
          return (
            <CartVariableMatch
              groupIds={this.props.teams.groupIds}
              key={`cart-variable-${currentMatchPayment.id}`}
              {...this.props}
            />
          );
        } if (currentMatchPayment.paymentType === 'event' || currentMatchPayment.paymentType === 'forfeit' || currentMatchPayment.paymentType === 'forfeit-covid') {
          return (
            <CartBasicMatch
              key={`cart-${currentMatchPayment.paymentType}-${currentMatchPayment.id}`}
              groupIds={this.props.teams.groupIds}
              {...this.props}
            />
          );
        } if (currentMatchPayment.paymentType === 'event-variable-addition') {
          return (
            <CartVariableMatch
              groupIds={this.props.teams.groupIds}
              key={`cart-variable-${currentMatchPayment.id}`}
              {...this.props}
            />
          );
        }
        return null;
      }
    }
    return null;
  }
}
